import XLSX from "xlsx";
import noDataHelper from '@/scripts/noDataHelper';

function toMissingDataCells(rows, missingRow) {

  let cells = [missingRow.heading ? missingRow.heading : 'Number of Rows with Values']; 
  missingRow.counts.forEach(c => cells.push(c ? formatValue(c) : 0));
  return cells;
}
function toMissingDataRow(rows, missingRow) {
  if (missingRow.title) {
    rows.push(row.suffix + ':' + row.title);
  }
  rows.push(toMissingDataCells(rows, missingRow));
}

function formatValue(value) {
  const intValue = parseInt(value);
  return intValue == value ? intValue : value;
  
}

function createMissingDataWorksheet(reportModel) {
  var rows = [];
  const dataModel = noDataHelper.getDataModel(reportModel.missingData);
  rows.push(['Insufficient data to generate the requested estimate']);
  rows.push([]);

  if (dataModel.note) {
    rows.push([dataModel.note]);
    rows.push([]);
  }
  rows.push(['', ...dataModel.columnHeadings.map(h => formatValue(h))]);
  dataModel.rows.forEach(r => toMissingDataRow(rows, r));
  rows.push([]);

  var ws = XLSX.utils.aoa_to_sheet(rows, { cellDates: true });
  return ws;
}

export default {
    createMissingDataWorksheet
}